// 同意書表示欄
import React, { useState, useEffect, memo } from 'react';
import Popup from '../molecules/Popup';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Heading from '../molecules/Heading';

interface Props {
  guarantor: string;
  title: string;
  text: string;
  is_disagree: boolean;
  is_disabled?: boolean;
  setIsGuarantorAgreement?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Agreement: React.FC<Props> = ({
  guarantor,
  title,
  text,
  is_disagree,
  is_disabled,
  setIsGuarantorAgreement,
}) => {
  const [show_modal, setShowModal] = useState(false);
  const [show_shelf, setShowShelf] = useState(false);
  const toggleShowShelf = () => setShowShelf(prev => !prev);
  const toggleShowModal = () => setShowModal(prev => !prev);
  const confirmConsentDocument = () => {
    if (typeof setIsGuarantorAgreement !== 'undefined') {
      setIsGuarantorAgreement(true);
    }
    setShowModal(prev => !prev);
  };

  // 同意・不同意によって棚の初期状態を決定
  useEffect(() => {
    setShowShelf(!is_disagree);
  }, [is_disagree]);

  const button = {
    label: '同意文書を確認',
    variant: 'success',
    handleClick: confirmConsentDocument,
  };

  return (
    <>
      <Heading label="同意・署名" size="m" />
      <ShelfInShelf
        id="agreement-text"
        is_open={show_shelf}
        handleClick={toggleShowShelf}
        label={`${guarantor}としての同意`}
      >
        <Annotation
          text={`同意書を表示して内容を確認し、この契約の${guarantor}として同意する場合には「同意する」ボタンを押して下さい。`}
        />
        <CenterButton
          btn_class="btn-base"
          label="同意書を表示する"
          handleClick={toggleShowModal}
          is_disabled={is_disabled}
        />
      </ShelfInShelf>
      <Popup
        title={title}
        sub_title={`${guarantor}としての同意確認`}
        text={text}
        toggleShow={show_modal}
        toggleClose={toggleShowModal}
        first_button={button}
      />
    </>
  );
};

export default memo(Agreement);
